import api from ".";
import { IScore } from "../types/score";
import cookiesModifier from "../utils/cookies";

export const getScores = async () => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`scores`);

        return res.data as IScore[];
    } catch (error) {
        throw error;
    }
}